import { Check, Clipboard } from '@phosphor-icons/react';
import { FC, useState } from 'react';

export const VakeClipboard: FC<{ infoValue: string }> = ({ infoValue }) => {
    const [isCopied, setIsCopied] = useState<boolean>(false);
    const handleClick = () => {
        setIsCopied(!isCopied);
        navigator.clipboard.writeText(infoValue);
        setTimeout(() => {
            setIsCopied(false);
        }, 1000);
    };
    if (!isCopied) {
        return <Clipboard size={20} color="white" onClick={handleClick} className="hover:cursor-pointer" />;
    } else {
        return <Check size={20} className="text-success-default" />;
    }
};
